import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3288fbc6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "mobile_logined_account"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "setellite_name" }, " OREUM-SAT ", -1))

import { storeToRefs } from 'pinia';

import AccountInfo from '@/components/common/AccountInfo.vue';
import EditPassword from '@/components/common/EditPassword.vue';
import IconButtons from '@/components/mobile/IconButtons.vue';
import useCommonStore from '@/store/storeCommon';
import useMemberStore from '@/store/storeMember';


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginedPanel',
  setup(__props) {

const { isImageMode } = storeToRefs(useCommonStore());
const { windowSize, showPanel, showModal } = useCommonStore();
const { accessedMemberInfo, getLevelImageSrc, getLevelName } = useMemberStore();

/**
 * 조건별 함수
 */
const qualificationFunction = (qualification: string): boolean => {
  switch (qualification) {
    case 'showLoginedPanel':
      return !!(showPanel.isMobileAccountInfo && accessedMemberInfo.name && !isImageMode.value && windowSize.width < windowSize.height);
    default:
      return false;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withCtx(() => [
      (qualificationFunction('showLoginedPanel'))
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", {
              class: _normalizeClass(["mobile_logined_account_inner", {opacity : _unref(showModal).isSuccess}])
            }, [
              _createElementVNode("img", {
                class: "side_logo",
                src: _unref(getLevelImageSrc)(_unref(accessedMemberInfo).level,'SideLogo'),
                alt: "side logo"
              }, null, 8, _hoisted_2),
              _createElementVNode("img", {
                class: "character",
                src: _unref(getLevelImageSrc)(_unref(accessedMemberInfo).level,''),
                alt: `${_unref(accessedMemberInfo).level}`
              }, null, 8, _hoisted_3),
              _createElementVNode("h2", {
                class: _normalizeClass(["character_name", _unref(getLevelName)()])
              }, _toDisplayString(_unref(getLevelName)()), 3),
              _hoisted_4,
              _createVNode(_TransitionGroup, {
                name: "fade",
                tag: "div",
                class: "contents"
              }, {
                default: _withCtx(() => [
                  (!_unref(showPanel).isEditPassword)
                    ? (_openBlock(), _createBlock(AccountInfo, { key: 0 }))
                    : (_openBlock(), _createBlock(EditPassword, { key: 1 }))
                ]),
                _: 1
              }),
              _createVNode(IconButtons, {
                class: _normalizeClass({'mobile_account_btn' : _unref(accessedMemberInfo).name})
              }, null, 8, ["class"])
            ], 2)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})